var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 17.597,
    viewBox: "0 0 22 17.597",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_action_export",
    d: "M14.764,969.168l-5.441.044c0,3.806.03,9.911.012,13.806h8.97a5.355,5.355,0,0,1,6.315-5.89v-6.2h-8.6a.457.457,0,0,1-.394-.225ZM6,972c.776,2.221,1.633,6.723,2.436,9v-9Zm17.609,6A4.385,4.385,0,1,0,28,982.38,4.381,4.381,0,0,0,23.609,977.995Zm.269,2.524h.037a.217.217,0,0,1,.125.031l2.686,1.649a.216.216,0,0,1,0,.368L24.04,984.21a.216.216,0,0,1-.331-.187v-.643H20.948a1.126,1.126,0,0,1-.306-.037.439.439,0,0,1-.137-.056.262.262,0,0,1-.119-.219v-1.374a.25.25,0,0,1,.119-.212.465.465,0,0,1,.137-.063,1.131,1.131,0,0,1,.306-.037h2.761v-.643a.216.216,0,0,1,.169-.219Z",
    transform: "translate(-6 -969.168)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.5e1c301ba201bd5f122973c0155b7373.svg";
export { ForwardRef as ReactComponent };